<template>
  <ItemForm
    :breadcrumbs="breadcrumbs"
    :value="{...defaultNew, itemCustomizers: []}"
  >
    <template #actions="{form, fields}">
      <v-btn
        :disabled="!form"
        color="success"
        class="mx-2"
        rounded
        @click="create(fields)"
      >
        Create
      </v-btn>
    </template>
  </ItemForm>
</template>

<script>
import ItemForm from '@/pages/App/MenuCreator/Items/__ItemForm__'
import { Item } from '@/store/models'
import { mapGetters } from 'vuex'
import createMixin from '@/mixins/apiCreateMixin'

export default {
  name: 'ItemNew',
  components: { ItemForm },
  mixins: [createMixin(Item)],
  data () {
    return {
      breadcrumbs: [
        {
          text: 'Items',
          exact: true,
          to: { name: 'App-MenuCreator-Items' }
        },
        {
          text: 'New',
          exact: true,
          to: { name: 'App-MenuCreator-Items-New' }
        }
      ]
    }
  },
  computed: {
    ...mapGetters('app', ['defaultNew'])
  }
}
</script>
